// extracted by mini-css-extract-plugin
export default {"errorMessage":"Captcha__errorMessage___dFtsl"};